import { Input } from "@/components/ui/input";
import { FinanceiroLabels } from "@/lib/labels/financeiro";

export function FinanceiroCurrencyInput({
	valueCents,
	onValueCentsChange,
	disabled,
	slot,
}: {
	valueCents: number;
	onValueCentsChange: (valueCents: number) => void;
	disabled?: boolean;
	slot: string;
}) {
	return (
		<Input
			data-slot={slot}
			type="text"
			inputMode="numeric"
			value={FinanceiroLabels.money(valueCents)}
			disabled={disabled}
			onChange={(event) => {
				const digits = event.currentTarget.value.replaceAll(/\D/gu, "");

				onValueCentsChange(digits.length === 0 ? 0 : Number(digits));
			}}
			className="font-mono tabular-nums"
		/>
	);
}
